import { render, staticRenderFns } from "./return_dialog.vue?vue&type=template&id=36cbdfb0&scoped=true"
import script from "./return_dialog.vue?vue&type=script&lang=js"
export * from "./return_dialog.vue?vue&type=script&lang=js"
import style0 from "./return_dialog.vue?vue&type=style&index=0&id=36cbdfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbdfb0",
  null
  
)

export default component.exports